import type { Translation } from '@subaio/api-types/shared'
import { type Store as StoreBase, storeCreate as storeCreateBase } from '@subaio/utils'
import { type ContainerState, ContainerStatus } from '@subaio/webapp/src/containers'

import type { User } from 'apiTypes/User'

export type UserAuth = { status: 'authenticated'; user: User } | { status: 'unauthenticated' } | { status: 'expired' }
export type UserAuthStatus = UserAuth['status']

export type State = ContainerState & {
	translation: Translation | null
	userAuth: UserAuth
}
export type Store = StoreBase<State>

export const defaultState: State = {
	page: { name: 'NotFound' },
	status: ContainerStatus.Running,

	translation: null,
	userAuth: { status: 'unauthenticated' },
	data: {},
}

export const storeCreate = () => storeCreateBase<State>(defaultState)

export const expireSession = (store: Store) => {
	const { page } = store.getState()
	store.set({
		userAuth: { status: 'expired' },
		...(page.name === 'Flow' && {
			// A new page reference cancels initialization and updates from the expired session.
			page: { ...page },
			status: ContainerStatus.Initializing,
			data: {},
		}),
	})
}
